import {combineReducers} from 'redux';
import {reducer as formReducer} from 'redux-form';
import {SUCCESS_SIGN_IN} from '../actions/authentication';
import app from './app';
import groupStorage from './app/tools/groupStorage';
import authentication from './authentication';
import entities from './entities';
import notifications from './notifications';

export default combineReducers({
  app,
  authentication,
  groupStorage,
  entities,
  form: formReducer.plugin({
    'sign-in-form': (state, action) => {
      switch (action.type) {
        case SUCCESS_SIGN_IN:
          return undefined;
        default:
          return state;
      }
    },
  }),
  notifications,
});



// WEBPACK FOOTER //
// ./src/reducers/index.js